module.exports = __webpack_public_path__ + "img/connection-right-3.5cc84ca7.png";